var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-modal",
    {
      ref: "modal",
      staticClass: "support-full-screen-modal",
      attrs: {
        id: "support-modal",
        "header-class": "support-modal-header",
        "cancel-title": _vm.$t("Cancel"),
        "ok-title": _vm.$t("Send"),
        centered: "",
        "ok-variant": "primary"
      },
      on: { ok: _vm.handleSubmit },
      scopedSlots: _vm._u([
        {
          key: "modal-header",
          fn: function(ref) {
            var close = ref.close
            return [
              _c(
                "div",
                { staticClass: "support-modal-header-content step4 w-100" },
                [
                  _c("div", { staticClass: "support-container h-100" }, [
                    _c("h1", {
                      staticClass: "page-title",
                      domProps: {
                        innerHTML: _vm._s(_vm.$t("support.modal.title"))
                      }
                    })
                  ])
                ]
              )
            ]
          }
        }
      ])
    },
    [
      _c("div", [
        _c("p", {
          staticClass: "modal-text",
          domProps: { innerHTML: _vm._s(_vm.$t("support.modal.welcome")) }
        }),
        _vm._v(" "),
        _c("p", {
          staticClass: "modal-text mt-2",
          domProps: { innerHTML: _vm._s(_vm.$t("support.modal.fill.in")) }
        })
      ]),
      _vm._v(" "),
      _c(
        "b-form-group",
        {
          staticClass: "small-text mt-2",
          attrs: {
            label: _vm.$t("support.modal.feedback.type"),
            "label-for": "feedback-type-input"
          }
        },
        [
          _c(
            "b-form-select",
            {
              attrs: { id: "feedback-type-input", required: "" },
              model: {
                value: _vm.feedbackType,
                callback: function($$v) {
                  _vm.feedbackType = $$v
                },
                expression: "feedbackType"
              }
            },
            _vm._l(_vm.feedbackTypes, function(type) {
              return _c("option", { domProps: { value: type.value } }, [
                _vm._v("\n        " + _vm._s(_vm.$t(type.text)) + "\n      ")
              ])
            }),
            0
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-form-group",
        {
          staticClass: "small-text",
          attrs: {
            label: _vm.$t("support.modal.content"),
            "invalid-feedback": _vm.content.invalidFeedback,
            "label-for": "content-input"
          }
        },
        [
          _c("b-form-textarea", {
            attrs: {
              state: _vm.content.state,
              id: "content-input",
              required: ""
            },
            model: {
              value: _vm.content.value,
              callback: function($$v) {
                _vm.$set(_vm.content, "value", $$v)
              },
              expression: "content.value"
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-8b7acf50", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8b7acf50","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/user/SupportModal.vue
// module id = h/uz
// module chunks = 0